<template>
  <div
    class="select-option"
    :class="{
      'select-option--selected': selected,
      'select-option--mobile': mobile,
      'select-option--hovered': hovered
    }"
  >
    <span
      v-if="icon"
      class="select-option__icon"
      :class="icon"
    />
    <div class="select-option__label">
      <template v-if="slots['base-option-content']">
        <slot
          name="base-option-content"
          :option-label="label"
          :option-value="value"
          :option-extra-data="extraData"
        />
      </template>
      <template v-else>
        <div v-html="optionLabel" />
      </template>
    </div>
    <span
      v-if="mobile"
      class="select-option__circle"
      :class="{
        'select-option__circle--selected': selected
      }"
    />
  </div>
</template>

<script setup lang="ts">
type Props = {
  label: string
  value?: string | number
  icon?: string
  extraData?: unknown
  selected?: boolean
  mobile?: boolean
  hovered?: boolean
  highlightLabel?: string
}

const props = withDefaults(defineProps<Props>(), {
  value: '',
  icon: '',
  extraData: undefined,
  selected: false,
  mobile: false,
  hovered: false,
  highlightLabel: ''
})

const slots = useSlots()

const optionLabel = computed(() => {
  if (props.highlightLabel.length > 0) {
    const label = props.label as string
    const matchString = label.match(new RegExp(props.highlightLabel, 'gmi'))

    if (matchString && matchString.length > 0) {
      return (props.label as string).replace(matchString[0], '<b>' + matchString[0] + '</b>')
    } else {
      return props.label
    }
  } else {
    return props.label
  }
})
</script>

<style lang="scss" scoped>
.select-option {
  padding: 0.5rem 1.2rem;
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 1.715;
  display: flex;
  align-items: center;
  transition: background-color $transition-time;

  &--selected,
  &--hovered {
    background-color: rgba(#e7e7e7, 0.4);
  }

  @media only screen and (min-width: 1024px) {
    &:hover {
      background-color: rgba(#e7e7e7, 0.4);
    }
  }

  &--mobile {
    padding: 1.4rem 1.6rem;
    line-height: 2rem;
    background-color: transparent !important;
    border-bottom: solid 0.1rem #e7e7e7;
  }

  &__icon {
    margin-right: 0.6rem;
    display: block;
  }

  &__label {
    max-width: 100%;
    margin-right: 1rem;
    text-wrap: balance;
  }

  &__circle {
    flex-shrink: 0;
    display: block;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    border: solid 0.1rem #8a8a8a;
    position: relative;
    margin-left: auto;

    &:before {
      content: '';
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      background-color: $link-color;
      position: absolute;
      top: 50%;
      left: 50%;
      display: none;
      margin-top: -0.3rem;
      margin-left: -0.3rem;
    }

    &--selected {
      border-color: $link-color;

      &:before {
        display: block;
      }
    }
  }
}
</style>
